import FormAnalytics from '../formAnalytics/formAnalytics'
import { FormNames } from '../formAnalytics/formEvents.types'
import { PortalProducts } from '../types/analytics.type'

class LoginAnalytics extends FormAnalytics {
  public constructor() {
    super(PortalProducts.ACCOUNT, FormNames.LOGIN)
  }
}

const loginAnalytics = new LoginAnalytics()

export default loginAnalytics
